import { useContext } from 'react'

import { PurchaseScheduleContext } from '@provider/Dashboard/PurchaseScheduleProvider'

import type { IPurchaseScheduleContext } from '@base/@types/providers/Dashboard/PurchaseScheduleProvider'

export default function usePurchaseSchedule(): IPurchaseScheduleContext {
  const context = useContext(PurchaseScheduleContext)

  return context
}
